import { gql } from 'graphql.macro';
import { orgContactFragment } from './common';

export const labFragment = gql`
    fragment labFields on Lab {
        _id
        name
        officialName
        organizationNumber
        contact {
            ...orgContactFields
        }
        active
        created {
            on
        }
        customerSettings {
            name
            type
            value
        }
        localeFormat {
            language
            date
            number
        }
        vismaCodingIds {
            unitId
            noVatCodingId
            vatCodingId
        }
    }
    ${orgContactFragment}
`;
